import React from "react";
import { BottomNav } from "./BottomNav";
import { TopNav } from "./TopNav";

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col'>
      {/* Desktop-only top navigation */}
      <TopNav />

      {/* Mobile: centred at max-w-mobile; Desktop: full width */}
      <div className='flex-1 flex justify-center md:justify-start md:block'>
        <div className='w-full max-w-mobile md:max-w-none relative flex flex-col min-h-full'>
          {/* pb-20 reserves space for the fixed mobile bottom nav */}
          <main className='flex-1 pb-20 md:pb-6'>{children}</main>
        </div>
      </div>

      {/* Mobile-only bottom navigation */}
      <BottomNav />
    </div>
  );
}
